import amapi from 'Api/amapi'

const initialState = {
  domains: [],
  queryResult: []
}
const initialState2 = {
  selectedDomain: '',
}

const state = { ...initialState, ...initialState2 }

const getters = {
  domains: state => {
    return state.domains.flat(2)
  },
  selectedDomain: state => {
    return state.selectedDomain
  },
  queryResult: state => {
    return state.queryResult
  }
}

const mutations = {
  SET_DOMAINS: (state, payload) => {
    state.domains = []

    state.domains.push(payload.main_domain)
    if (payload.addon_domains.length !== 0) {
      state.domains.push(payload.addon_domains)
    }
    if (payload.parked_domains.length !== 0) {
      state.domains.push(payload.parked_domains)
    }
    if (payload.sub_domains.length !== 0) {
      state.domains.push(payload.sub_domains)
    }
  },
  SET_DOMAIN: (state, domain) => {
    state.selectedDomain = domain
  },
  SET_QUERY_RESULT (state, payload) {
    state.queryResult = payload
  },

  CLEAR_STORE (state) {
    const s = initialState

    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  }
}

const actions = {
  async getDomains ({ commit }, _username) {
    // Get domains
    const data = {
      uapi_module: 'DomainInfo',
      uapi_function: 'list_domains',
      _username,
    }

    try {
      const response = await amapi.cpanel_uapi({ ...data })
      commit('SET_DOMAINS', response.data)
    } catch (e) {
      throw e
    }
  },
  async batchQuery ({ commit, getters }, { single = false, _username }) {
    // console.log(this.$route)
    let obj = {}

    if (!single) {
      for (let i = 0; i < getters.domains.length; i++) {
        obj[`domain-${i}`] = getters.domains[i]
      }
    } else {
      obj['domain'] = getters.selectedDomain
    }

    const readyObj = {
      uapi_module: 'Batch',
      uapi_function: 'strict',
      _username,
      'command-0': JSON.stringify(['DNS', 'has_local_authority', obj]),
      'command-1': JSON.stringify(['EmailAuth', 'validate_current_dkims', obj]),
      'command-2': JSON.stringify(['EmailAuth', 'validate_current_spfs', obj]),
      'command-3': JSON.stringify(['EmailAuth', 'validate_current_ptrs', obj]),
    }

    try {
      const response = await amapi.cpanel_uapi(readyObj)

      commit('SET_QUERY_RESULT', response.data)
    } catch (e) {
      throw e
    }
  },
  async setDkimRecord ({ commit }, payload) {
    try {
      const data = {
        uapi_module: 'EmailAuth',
        uapi_function: 'enable_dkim',
        ...payload
      }
      await amapi.cpanel_uapi({ ...data })
    } catch (e) {
      throw e
    }
  },
  async setSpfRecord ({ commit }, payload) {
    try {
      const data = {
        uapi_module: 'EmailAuth',
        uapi_function: 'install_spf_records',
        ...payload
      }
      await amapi.cpanel_uapi({ ...data })
    } catch (e) {
      throw e
    }
  }
}
const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
